import { Component, Vue, Prop } from 'vue-property-decorator';
import { FooterLogo } from './components';
import { NON_PROMOTED_CHANNEL_IDS } from '@/constants/channel';

@Component({
    components: {
        FooterLogo
    }
})
export default class AppFooter extends Vue {
    @Prop({ default: '#000000' })
    color: string;

    @Prop({ default: '#000000' })
    logoColor: string;

    @Prop({ default: '' })
    channelId: string;

    get isNonPromoted(): boolean {
        return NON_PROMOTED_CHANNEL_IDS.has(this.channelId.toLowerCase());
    }
}
